import React, { useState, useRef, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useRecoilState, useRecoilValue } from 'recoil';
import navHeaderAtom from '../atoms/navHeaderAtom';
import { toast } from 'react-toastify';
import { url } from '../utils/config';
import { useNavigate } from 'react-router-dom';
import arrowBlack from '../assets/icons/arrow_black.png'
import axios from 'axios';
import { inputStyleTwo } from '../utils/style';
import myInfoAtom from '../atoms/myInfoAtom';
import toggleAtom from '../atoms/toggleAtom';
import loaderStateAtom from "../atoms/loaderStateAtom";

const CreateNewAppointment = () => {

  const [header, setHeader] = useRecoilState(navHeaderAtom)
  const info = useRecoilValue(myInfoAtom)
  const [cars, setCars] = useState([])
  const [fleetCustomer, setFleetCustomer] = useState([])
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    confirmEmail: '',
    phoneCode: '+1',
    phone: '',
    year: '',
    make: '',
    model: '',
    // color: '',
    problemDescription: '',
    location: '',
    date: '',
    time: '',
    technicianId: info.data?.id,
    termsAccepted: false,
    id: '',
    customerType: ''
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const locationInputRef = useRef(null);
  const navigate = useNavigate();
  const [carInfo, setCarInfo] = useState([])
  const toggleValue = useRecoilValue(toggleAtom)
  const [showLoader, setShowLoader] = useRecoilState(loaderStateAtom)

  // Initialize Google Places Autocomplete
  useEffect(() => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!apiKey) {
      console.error('Google Maps API key is missing');
      return;
    }

    if (window.google && locationInputRef.current) {
      const autocomplete = new window.google.maps.places.Autocomplete(locationInputRef.current, {
        fields: ["address_components", "formatted_address", "geometry"],
        types: ["address"]
      });

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const address = place.formatted_address;

        setFormData(prev => ({
          ...prev,
          location: address
        }));

        // Clear location error if exists
        if (touched.location) {
          setErrors(prev => ({
            ...prev,
            location: ''
          }));
        }
      });
    }

    fetchCars()
    fetchFleetCustomer()
  }, []);

  async function fetchCars() {
    try {
      const token = window.localStorage.getItem('token');
      const headers = { authorization: `bearer ${token}` };
      const { data } = await axios.get(url + '/cars', { headers })
      setCars(data.data)
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchCarInfo(id) {
    try {
      const token = window.localStorage.getItem('token');
      const headers = { authorization: `bearer ${token}` };
      const { data } = await axios.get(url + `/fleet_customer_car/${id}`, { headers })
      setCarInfo(data.data)
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchFleetCustomer() {
    try {
      const token = window.localStorage.getItem('token');
      const headers = { authorization: `bearer ${token}` };
      const { data } = await axios.get(url + '/fleet_customers', { headers })
      setFleetCustomer(data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const validateField = (name, value) => {
    switch (name) {
      case 'name':
        return value.trim() ? '' : 'Name is required';
      case 'email':
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ''
          : 'Please enter a valid email address';
      case 'confirmEmail':
        return value === formData.email
          ? ''
          : 'Email addresses do not match';
      case 'phoneCode':
        return value ? '' : 'Code is required';
      case 'phone':
        if (toggleValue === "b2c") {
          const phoneRegex = /^[0-9]{10}$/;
          return phoneRegex.test(value)
            ? ''
            : 'Please enter a valid 10-digit phone number';
        } else {
          return '';
        }
      case 'year':
        const yearNum = parseInt(value);
        return value.trim() && yearNum >= 1900 && yearNum <= new Date().getFullYear()
          ? ''
          : 'Please enter a valid year';
      case 'make':
        return value.trim() ? '' : toggleValue === "b2b" ? 'Car is required' : 'Make is required';
      case 'model':
        return value.trim() ? '' : 'Model is required';
      // case 'color':
      //   return value.trim() ? '' : 'Color is required';
      case 'location':
        return value.trim() ? '' : 'Location is required';
      case 'problemDescription':
        return value.trim().length >= 10
          ? ''
          : 'Please provide a detailed description (minimum 10 characters)';
      case 'date':
        const selectedDate = new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return value && selectedDate >= today
          ? ''
          : 'Please select a future date';
      case 'time':
        return value ? '' : 'Please select your preferred time';
      default:
        return '';
    }
  };

  const handleSelectChange = (e, type) => {
    const { name, value } = e.target;
    if (type === "car") {
      const { id, make, model, year } = JSON.parse(value);
      setFormData(prev => ({
        ...prev,
        car_id: id,
        make: make,
        model: model,
        year: year
      }));
    } else {
      const { id, email, name: fleetName, phone, address } = JSON.parse(value);
      setCarInfo([]);
      setFormData(prev => ({
        ...prev,
        email: email,
        confirmEmail: email,
        name: fleetName,
        phone: phone,
        id: id,
        customerType: 'fleet',
        location: address,
        fleet_customer_id: id
      }));
      fetchCarInfo(id);
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === 'checkbox' ? checked : value;

    setFormData(prev => ({
      ...prev,
      [name]: fieldValue,
    }));

    if (touched[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: validateField(name, fieldValue)
      }));
    }

    // Special case for email field - validate confirmEmail if it's been touched
    if (name === 'email' && touched.confirmEmail) {
      setErrors(prev => ({
        ...prev,
        confirmEmail: formData.confirmEmail === value ? '' : 'Email addresses do not match'
      }));
    }
  };

  const handlePhoneChange = (value) => {
    setFormData(prev => ({
      ...prev,
      phone: value
    }));

    if (touched.phone) {
      setErrors(prev => ({
        ...prev,
        phone: validateField('phone', value)
      }));
    }
  };

  const handleBlur = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === 'checkbox' ? checked : value;

    setTouched(prev => ({
      ...prev,
      [name]: true
    }));

    setErrors(prev => ({
      ...prev,
      [name]: validateField(name, fieldValue)
    }));
  };

  const handleSubmit = async (e) => {
    setShowLoader(true)
    e.preventDefault();

    const newErrors = {};
    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });

    // Additional check to ensure emails match
    if (formData.email !== formData.confirmEmail) {
      newErrors.confirmEmail = 'Email addresses do not match';
    }

    setErrors(newErrors);
    setTouched(Object.keys(formData).reduce((acc, key) => ({ ...acc, [key]: true }), {}));

    if (Object.keys(newErrors).length > 0) {
      setShowLoader(false);
      return;
    }


    try {
      // Combine phone code and number
      const submissionData = {
        ...formData,
        phone: `${formData.phoneCode}${formData.phone}`, // Combine phone code and number
        phoneCode: undefined, // Remove separate phone code
        confirmEmail: undefined // Remove confirmEmail as it's not needed for submission
      };


      let response;
      // Make API call
      if (toggleValue === "b2c") {
        response = await axios.post(
          `${url}/booking`,
          submissionData,
        );
      } else {
        response = await axios.post(
          `${url}/fleet_booking`,
          submissionData,
        );
      }
      if (response.status === 200) {
        toast.success('Appointment created successfully!', { autoClose: 3000 });
        // Redirect to home page after successful appointment creation
        setTimeout(() => {
          navigate('/');
        }, 1000); // Short delay to allow the user to see the success message

      } else {
        toast.error(response.data.message || 'Error creating appointment');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error creating appointment');
      setShowLoader(false)
    }

  };

  const inputClassName = "w-full px-3 py-2 border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-colors";
  const labelClassName = "block text-sm font-medium text-gray-700 mb-1";
  const requiredFieldLabel = <span className="text-red-500">*</span>;

  function getMakeList() {
    const make = [];
    cars.forEach(car => {
      if (!make.includes(car.make)) {
        make.push(car.make)
      }
    })
    return make.sort();
  }

  function getModelList() {
    const model = []
    cars.filter(car => car.make === formData.make).forEach(car => { if (!model.includes(car.model)) model.push(car.model) });
    return model.sort();
  }

  // Error message component
  const ErrorMessage = ({ error }) => (
    error ? <p className="text-red-500 text-sm mt-1">{error}</p> : null
  );

  return (
    <div className="h-[calc(100vh-64px)] overflow-y-auto bg-gray-50">
      <div className="max-w-2xl mx-auto p-4">
        <div className='flex'>
          <button
            className="p-2 bg-gray-100 rounded-full sticky top-0"
            onClick={() => { navigate('/') }}
          >
            <img src={arrowBlack} className="w-5 h-5" alt="back" />
          </button>
          <span className='text-xl m-2 font-bold'> {toggleValue === "b2b" ? "Fleet" : "Individual"} Appointment</span>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">

          {/* Personal Information Section */}
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <h3 className="text-base font-bold text-black mb-3">Personal Information</h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="name" className={labelClassName}>Name {requiredFieldLabel}</label>
                {toggleValue === "b2b" ?
                  (
                    <select
                      onChange={(e) => handleSelectChange(e, "fleet")}
                      className={inputStyleTwo}
                      id="name"
                      name="name"
                      onBlur={handleBlur}
                    >
                      <option value={""}>--Select--</option>
                      {fleetCustomer.map((record, ind) => <option key={ind} value={JSON.stringify(record)}>{record.name}</option>)}
                    </select>)
                  : (
                    <input
                      id="name"
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter your name"
                      required
                      className={`${inputClassName} ${errors.name ? 'border-red-500' : ''}`}
                    />
                  )}
                <ErrorMessage error={errors.name} />
              </div>

              <div>
                <label htmlFor="email" className={labelClassName}>Email {requiredFieldLabel}</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your email"
                  disabled={toggleValue === "b2b"}
                  required
                  className={`${inputClassName} ${errors.email ? 'border-red-500' : ''}`}
                />
                <ErrorMessage error={errors.email} />
              </div>

              <div>
                <label htmlFor="confirmEmail" className={labelClassName}>Confirm Email {requiredFieldLabel}</label>
                <input
                  id="confirmEmail"
                  type="email"
                  name="confirmEmail"
                  value={formData.confirmEmail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={toggleValue === "b2b"}
                  placeholder="Please confirm your email"
                  required
                  className={`${inputClassName} ${errors.confirmEmail ? 'border-red-500' : ''}`}
                />
                <ErrorMessage error={errors.confirmEmail} />
              </div>

              <div className="md:col-span-2 flex gap-4">
                {toggleValue === "b2c" && <div className="w-24">
                  <label htmlFor="phoneCode" className={labelClassName}>Code {requiredFieldLabel}</label>
                  <input
                    type="text"
                    id="phoneCode"
                    name="phoneCode"
                    value={formData.phoneCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="+1"
                    required
                    disabled
                    className={`${inputClassName} ${errors.phoneCode ? 'border-red-500' : ''} bg-gray-100`}
                    maxLength="3"
                  />
                  {touched.phoneCode && errors.phoneCode && (
                    <p className="mt-1 text-sm text-red-500">{errors.phoneCode}</p>
                  )}
                </div>
                }

                <div className="flex-1">
                  <label htmlFor="phone" className={labelClassName}>Phone Number {requiredFieldLabel}</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    disabled={toggleValue === "b2b"}
                    placeholder="Enter your phone number"
                    className={`${inputClassName} ${errors.phone ? 'border-red-500' : ''}`}
                    maxLength="14"
                  />
                  {touched.phone && errors.phone && (
                    <p className="mt-1 text-sm text-red-500">{errors.phone}</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Vehicle Information Section */}

          <div className="bg-white p-4 rounded-lg shadow-sm">
            <h3 className="text-base font-bold text-black mb-3">Vehicle Information</h3>
            {
              toggleValue === "b2c" ?
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div>
                    <label htmlFor="make" className={labelClassName}>Make {requiredFieldLabel}</label>
                    <select
                      onChange={handleChange}
                      className={inputStyleTwo}
                      name="make"
                      value={formData.make}
                      onBlur={handleBlur}
                      required
                    >
                      <option value={""}>--Select--</option>
                      {getMakeList().map((make, ind) => <option key={ind} value={make}>{make}</option>)}
                    </select>
                    <ErrorMessage error={errors.make} />
                  </div>

                  <div className="md:col-span-2">
                    <label htmlFor="model" className={labelClassName}>Model {requiredFieldLabel}</label>
                    <select
                      onChange={handleChange}
                      className={inputStyleTwo}
                      name="model"
                      value={formData.model}
                      onBlur={handleBlur}
                      required
                    >
                      <option value={""}>--Select--</option>
                      {getModelList().map((make, ind) => <option key={ind} value={make}>{make}</option>)}
                    </select>
                    <ErrorMessage error={errors.model} />
                  </div>

                  {/* <div className="md:col-span-2">
                <label htmlFor="color" className={labelClassName}>Color {requiredFieldLabel}</label>
                <input
                  id="color"
                  type="text"
                  name="color"
                  value={formData.color}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Color"
                  required
                  className={`${inputClassName} ${errors.color ? 'border-red-500' : ''}`}
                />
                <ErrorMessage error={errors.color} />
              </div> */}
                  <div>
                    <label htmlFor="year" className={labelClassName}>Year {requiredFieldLabel}</label>
                    <select
                      onChange={handleChange}
                      className={inputStyleTwo}
                      name="year"
                      value={formData.year}
                      onBlur={handleBlur}
                      required
                    >
                      <option value={""}>--Select--</option>
                      {cars.filter(car => car.make === formData.make && car.model === formData.model).sort((a, b) => a.year - b.year).map((car, index) =>
                        <option key={index} value={car.year}>{car.year}</option>)}
                    </select>
                    <ErrorMessage error={errors.year} />
                  </div>
                </div>
                :
                <div>
                  <select
                    onChange={(e) => handleSelectChange(e, "car")}
                    className={inputStyleTwo}
                    id="make"
                    name="make"
                    onBlur={handleBlur}
                  >
                    <option value={""}>--Select--</option>
                    {carInfo.map((record, ind) => <option key={ind} value={JSON.stringify(record)}>{`${record.make}-${record.model}-${record.year}-(${record.vin})-${record.plate}`}</option>)}
                  </select>
                  <ErrorMessage error={errors.make} />
                </div>
            }
          </div>

          {/* Additional Information Section */}
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <h3 className="text-base font-bold text-black mb-3">Additional Information</h3>

            <div className="space-y-4">
              <div>
                <label htmlFor="problemDescription" className={labelClassName}>Problem Description {requiredFieldLabel}</label>
                <textarea
                  id="problemDescription"
                  name="problemDescription"
                  value={formData.problemDescription}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Describe the issue with your vehicle"
                  required
                  className={`${inputClassName} min-h-[120px] resize-y ${errors.problemDescription ? 'border-red-500' : ''}`}
                />
                <ErrorMessage error={errors.problemDescription} />
              </div>

              <div>
                <label htmlFor="location" className={labelClassName}>Location {requiredFieldLabel}</label>
                <input
                  ref={locationInputRef}
                  id="location"
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Start typing an address..."
                  required
                  disabled={toggleValue === "b2b"}
                  className={`${inputClassName} ${errors.location ? 'border-red-500' : ''}`}
                />
                <ErrorMessage error={errors.location} />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="date" className={labelClassName}>Preferred Date {requiredFieldLabel}</label>
                  <input
                    id="date"
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    min={new Date().toISOString().split('T')[0]}
                    max="2100-12-31"
                    onBlur={handleBlur}
                    required
                    className={`${inputClassName} ${errors.date ? 'border-red-500' : ''}`}
                  />
                  <ErrorMessage error={errors.date} />
                </div>
                <div>
                  <label htmlFor="time" className={labelClassName}>Preferred Time {requiredFieldLabel}</label>
                  <select
                    id="time"
                    name="time"
                    value={formData.time}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    className={`${inputClassName} ${errors.time ? 'border-red-500' : ''}`}
                  >
                    <option value="">Select a time slot</option>
                    <option value="8:00 AM - 11:00AM">8:00 AM - 11:00AM</option>
                    <option value="11:00 AM - 3:00 PM">11:00 AM - 3:00 PM</option>
                    <option value="3:00 PM - 6:00 PM">3:00 PM - 6:00 PM</option>
                  </select>
                  <ErrorMessage error={errors.time} />
                </div>
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2.5 px-4 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 mt-6"
          >
            Create Appointment
          </button>
        </form>
      </div >
    </div >
  );
};

export default CreateNewAppointment;